module.exports = __webpack_public_path__ + "img/delivery3_green.c06f8fd6.svg";